import {DefaultTheme} from 'styled-components';

// eslint-disable-next-line no-restricted-imports -- Intended
import {isNil, path, split} from 'ramda';

import {Nullish} from 'shared/web';

import {ThemeColorPath} from './foundationTheme';

export function getColorByPath(
  color: ThemeColorPath | Nullish,
  theme: DefaultTheme
): string | undefined {
  if (isNil(color)) {
    return undefined;
  }
  return path(split('.', color), theme.colors);
}
